<template>
  <div>
    Sample was ready to make
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
  },
}
</script>
